export default [
  {
    path: "/dashboard",
    name: "dashboard",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/orders",
    name: "orders",
    component: () =>
      import(/* webpackChunkName: "orders" */ "@/views/Orders/Index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/orders/new",
    name: "new-order",
    component: () =>
      import(/* webpackChunkName: "new order" */ "@/views/Orders/New"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/sales",
    name: "sales",
    component: () =>
      import(/* webpackChunkName: "sales" */ "@/views/Sales/Index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/sales/new",
    name: "new-sale",
    component: () =>
      import(/* webpackChunkName: "new sale" */ "@/views/Sales/Create"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/sales/:id/edit",
    name: "edit-sale",
    component: () =>
      import(/* webpackChunkName: "edit sale" */ "@/views/Sales/Edit"),
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/income",
    name: "incomes",
    component: () =>
      import(/* webpackChunkName: "incomes" */ "@/views/Income/Index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/losses",
    name: "losses",
    component: () =>
      import(/* webpackChunkName: "losses" */ "@/views/Losses/Index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/products",
    name: "products",
    component: () =>
      import(/* webpackChunkName: "products" */ "@/views/Products/Index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/products/new",
    name: "new-product",
    component: () =>
      import(/* webpackChunkName: "settings" */ "@/views/Products/Create"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/products/:id",
    name: "product-details",
    component: () =>
      import(
        /* webpackChunkName: "productDetails" */ "@/views/Products/Details"
      ),
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/stocks",
    name: "stocks",
    component: () =>
      import(/* webpackChunkName: "stocks" */ "@/views/Stocks/Index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/branches",
    name: "branches",
    component: () =>
      import(/* webpackChunkName: "branches" */ "@/views/Branches/Index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/employees",
    name: "employees",
    component: () =>
      import(/* webpackChunkName: "employees" */ "@/views/Employees/Index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/employees/:id",
    name: "employee-details",
    component: () =>
      import(
        /* webpackChunkName: "employee-details" */ "@/views/Employees/Details"
      ),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/customers",
    name: "customers",
    component: () =>
      import(/* webpackChunkName: "employees" */ "@/views/Customers/Index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/customers/:id",
    name: "customer-details",
    component: () =>
      import(
        /* webpackChunkName: "employee-details" */ "@/views/Customers/Details"
      ),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/settings",
    name: "settings",
    component: () =>
      import(/* webpackChunkName: "settings" */ "@/views/Settings/Index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/settings/mercadopago",
    name: "mercadopago",
    component: () =>
      import(/* webpackChunkName: "settings" */ "@/views/Settings/MercadoPago"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/tables",
    name: "tables",
    component: () =>
      import(/* webpackChunkName: "settings" */ "@/views/Tables/Index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/tables/new",
    name: "new-table",
    component: () =>
      import(/* webpackChunkName: "settings" */ "@/views/Tables/Create"),
    meta: {
      requiresAuth: true
    }
  }
];
